import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Car, Inbox, KeyRound, Settings as SettingsIcon, Repeat, MessageSquare, LogOut, Trash2 } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { api } from "../../lib/api";

const links = [
  { to: "/admin", label: "Vehicles", icon: Car, end: true },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare, key: "messages" },
  { to: "/admin/test-drives", label: "Test Drives", icon: KeyRound, key: "test_drives" },
  { to: "/admin/trade-ins", label: "Trade-Ins", icon: Repeat, key: "trade_ins" },
  { to: "/admin/trash", label: "Trash", icon: Trash2, key: "trash", neutralBadge: true },
  { to: "/admin/settings", label: "Business Info", icon: SettingsIcon },
];

export default function AdminShell() {
  const { admin, logout } = useAuth();
  const nav = useNavigate();
  const [counts, setCounts] = useState({ messages: 0, test_drives: 0, trade_ins: 0, trash: 0 });

  useEffect(() => {
    let mounted = true;
    const fetchCounts = async () => {
      try {
        const { data } = await api.get("/admin/inbox-summary");
        if (mounted) setCounts(data);
      } catch { /* ignore */ }
    };
    fetchCounts();
    const t = setInterval(fetchCounts, 30000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  return (
    <div data-testid="admin-shell" className="pt-28 pb-24 max-w-[1500px] mx-auto px-6 md:px-10">
      <div className="flex items-start justify-between flex-wrap gap-4 mb-8">
        <div>
          <div className="overline flex items-center gap-2"><Inbox size={12} /> Admin</div>
          <div className="text-white/50 text-sm mt-1">Signed in as {admin?.email}</div>
        </div>
        <button data-testid="admin-logout" onClick={() => { logout(); nav("/"); }} className="btn-outline">
          <LogOut size={14} /> Sign Out
        </button>
      </div>

      <div className="glass rounded-full p-1.5 mb-10 inline-flex gap-1 flex-wrap max-w-full overflow-auto no-scrollbar" data-testid="admin-tabs">
        {links.map((l) => {
          const count = l.key ? counts[l.key] : 0;
          return (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-tab-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-colors whitespace-nowrap ${
                  isActive ? "bg-[var(--primary)] text-white" : "text-white/60 hover:text-white"
                }`
              }
            >
              <l.icon size={14} />
              {l.label}
              {count > 0 && (
                <span className="ml-1 min-w-[20px] h-5 px-1.5 rounded-full bg-white/20 text-[10px] font-semibold flex items-center justify-center">
                  {count}
                </span>
              )}
            </NavLink>
          );
        })}
      </div>

      <Outlet />
    </div>
  );
}
